import React from 'react';
import { X, Check, AlertTriangle, Loader } from 'lucide-react';

interface CaptchaStatusModalProps {
  isOpen: boolean;
  onClose: () => void;
  status: 'verifying' | 'success' | 'failed';
  message: string;
  onAction?: () => void;
  actionText?: string;
}

const CaptchaStatusModal: React.FC<CaptchaStatusModalProps> = ({
  isOpen,
  onClose,
  status,
  message,
  onAction,
  actionText
}) => {
  if (!isOpen) return null;

  const getStatusConfig = () => {
    switch (status) {
      case 'verifying':
        return {
          icon: Loader,
          iconClass: 'animate-spin text-blue-600',
          bgClass: 'bg-blue-100',
          title: 'Verifying CAPTCHA...'
        };
      case 'success':
        return {
          icon: Check,
          iconClass: 'text-white',
          bgClass: 'bg-gradient-to-r from-[#0F796B] to-[#6FDC95]',  
          title: 'CAPTCHA Verification Complete'
        };
      case 'failed':
        return {
          icon: AlertTriangle,
          iconClass: 'text-white',
          bgClass: 'bg-gradient-to-r from-[#d92b1e] to-[#b04a43]',
          title: 'CAPTCHA Verification Failed'
        };
      default:
        return {
          icon: Check,
          iconClass: 'text-green-600',
          bgClass: 'bg-green-100',
          title: 'CAPTCHA Status'
        };
    }
  };

  const config = getStatusConfig();
  const IconComponent = config.icon;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        {/* Header */}
        {status !== 'success' &&  <div className="px-6 pt-4 ">
          {/* <div className="flex items-center justify-between"> */}
            {/* <h2 className="text-xl font-semibold text-gray-900">{config.title}</h2> */}
           <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors block ml-auto"
            >
              <X className="h-7 w-7" />
            </button>
          {/* </div> */}
        </div>}

        {/* Content */}
        <div className={`text-center ${status === 'success' ? 'p-10' : 'p-6'}`}>
          {/* Status Icon */}
          <div className={`mx-auto mb-4 w-20 h-20 ${config.bgClass} rounded-full flex items-center justify-center`}>
            <IconComponent className={`h-10 w-10 ${config.iconClass}`} />
          </div>

          {/* Message */}
          <p className={`text-gray-600 mb-6 ${status === 'success' ? 'text-xl' : 'text-base'}`}>
            {message}
          </p>

          {/* Action Button */}
          {actionText && onAction && status !== 'verifying' && (
            <button
              onClick={onAction}
              className={`w-full py-3 px-4 rounded-lg transition-colors font-medium ${
                status === 'success' 
                  ? 'bg-green-600 text-white hover:bg-green-700' 
                  : 'bg-red-600 text-white hover:bg-red-700'
              }`}
            >
              {actionText}
            </button>
          )}

          {/* Close Button for verifying state */}
          {status === 'verifying' && (
            <button
              onClick={onClose}
              className="w-full bg-gray-600 text-white py-3 px-4 rounded-lg hover:bg-gray-700 transition-colors font-medium"
            >
              Cancel
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CaptchaStatusModal; 